import request from '@/router/axios'
import qs from 'qs'
// 获取企业信息列表
export function addressList(query) {
  return request({
    url: '/companyProject/getMyAdds',
    method: 'post',
    params: query
  })
}

// 工人群组
export function getGroupList(query) {
    return request({
      url: '/workerGroup/getMyGroups',
      method: 'post',
      params: query
    })
  }
// 工人
export function getWorkerList(query) {
  return request({
    url: '/workerGroup/getMyWorkers',
    method: 'post',
    params: query
  })
}
// 获取企业是否认证
export function companyVerification(query) {
  return request({
    url: '/company/getAuthInfo',
    method: 'post',
    params: query
  })
}
// 获取订单编号
export function getOrderCode(query) {
  return request({
    url: '/platformProject/getOrderCode',
    method: 'post',
    params: query
  })
}
// 获取项目工作内容列表
export function getProjectContents(query) {
  return request({
    url: '/companyProject/getProjectContents',
    method: 'post',
    params: query
  })
}
//导入项目
export function putProjectContents(query) {
  return request({
    url: '/uploadProjectContent/uploadProjectContent',
    method: 'post',
    params: query
  })
}
//上传
export function putProjectfile(query) {
  return request({
    url: '/files/fileUpload',
    method: 'post',
    params: query
  })
}
//保存
export function insertOrUpdate(query) {
  return request({
    url: '/platformProject/insertOrUpdate',
    method: 'post',
    params: query,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
//保存
export function insertOrUpdateCompanyProject(query) {
  return request({
    url: '/companyProject/insertOrUpdate',
    method: 'post',
    params: query,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
//根据城市查询估价
export function getPredictPriceForCcode(query){
  return request({
    url:'/predictPrice/getPredictPriceForCcode',
    method:'post',
    params:query,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

//查询 地址
export function getAddressList(query){
  return request({
    url:'/map/search',
    method:'post',
    params:query,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

//查询 额外费用
export function getProjectExtraCosts(query){
  return request({
    url:'/projectExecution/getProjectExtraCosts',
    method:'post',
    params:query,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
